import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const HomeHowItWorksSection: React.FC = () => {
  const { t } = useTranslation();
  const s = t("howItWorksSection", { returnObjects: true }) as {
    title: string;
    steps: { number: string; title: string; desc: string }[];
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-main text-center mb-14">
          {s.title}
        </h2>
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connector line (desktop only) */}
          <div className="hidden md:block absolute top-6 left-[16.5%] right-[16.5%] h-px bg-gray-200 z-0" />

          {s.steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="text-center relative z-10"
            >
              <div className="w-12 h-12 rounded-full bg-main text-white font-extrabold flex items-center justify-center text-sm mx-auto mb-5 shadow-md">
                {step.number}
              </div>
              <h3 className="font-bold text-main text-base mb-2">{step.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeHowItWorksSection;
